import {Component} from "@angular/core";
import {BusinessService} from "../../../services/data/business.service";

@Component({
    selector: 'stats-detail',
    template: require('./stats-detail.component.html'),
    styles: [
        require('./stats-detail.component.scss')
    ]
})

export class StatsDetailComponent {

    constructor(private businessService:BusinessService) {
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/dashboard/stats-detail/stats-detail.component.ts